import { combineReducers } from 'redux';
import { starships } from './starship';

// For now we only have a reducer, but using
// combineReducers so it is easily extendable
export default combineReducers({ starships });